import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../common/Button';
import Typography from '../common/Typography';
import { Modal, ModalContent, ModalCloseButton } from '../common';
import { joinSessionByCode } from '../../services/privateSessionService';

const JoinSessionModal = ({ isOpen, onClose, currentUser }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [joinCode, setJoinCode] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!joinCode.trim()) {
      setError('Please enter a join code');
      return;
    }

    if (joinCode.trim().length !== 8) {
      setError('Join code must be 8 characters long');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const session = await joinSessionByCode(joinCode.trim().toUpperCase(), currentUser.id);
      navigate(`/session/${session.id}`);
    } catch (err) {
      console.error('Error joining session:', err);
      setError(err.message || 'Failed to join session');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (value.length <= 8) {
      setJoinCode(value);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnBackdropClick={!loading}>
      <ModalContent size="small" padding={false} className="overflow-hidden">
        <div className="flex items-center justify-between border-b border-border-medium p-4 sm:p-6">
          <Typography variant="h5" className="font-semibold">
            Join Private Session
          </Typography>
          <ModalCloseButton onClose={onClose} className="static" />
        </div>

        <form onSubmit={handleSubmit} className="p-4 sm:p-6">
          <div className="mb-6">
            <label className="block text-sm font-medium text-text-primary mb-2">Enter Join Code</label>
            <input
              type="text"
              value={joinCode}
              onChange={handleInputChange}
              className="w-full form-input px-4 py-3 text-center text-2xl font-mono border border-border-medium rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary bg-surface text-text-primary uppercase tracking-wider"
              placeholder="ABC123XY"
              maxLength={8}
              required
            />
            <Typography variant="caption" className="text-text-muted mt-1 block">
              Enter the 8-character join code shared by the session host
            </Typography>
          </div>

          {error && (
            <div className="bg-danger-light border border-danger text-danger-dark px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          <div className="flex flex-col-reverse gap-2 sm:flex-row sm:gap-3">
            <Button type="button" variant="secondary" onClick={onClose} className="flex-1">
              Cancel
            </Button>
            <Button type="submit" disabled={loading || joinCode.length !== 8} className="flex-1">
              {loading ? 'Joining...' : 'Join Session'}
            </Button>
          </div>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default JoinSessionModal;
